import { ThreeColumnMediaFullProps } from '@/components/_rebrand/ThreeColumnMediaFull';
import LottieMedia from '@/components/_rebrand/LottieMedia';
import SerifAndSansSerifHeadline from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import { parseHtml } from '@/lib/parse-html';
import Image from 'next/image';
import { BenefitFromCraft, MapMainImageProps } from './ThreeBenefits.types';

export const mapBenefits = (features: BenefitFromCraft[]): ThreeColumnMediaFullProps['features'] => {
  const benefits: ThreeColumnMediaFullProps['features'] = features.map((feature) => ({
    icon: <Image src={feature.icon[0].url} width={feature.icon[0].width} height={feature.icon[0].height} style={{ width: 16 }} alt={feature.icon[0].title} />,
    title: feature.headline,
    description: parseHtml(feature.description),
  }));

  return benefits;
}

export const mapMainImage = (
  { featuredImage, mobileFeaturedImage, useLottieFile, lottieFile }: MapMainImageProps,
): ThreeColumnMediaFullProps['mainImage'] => {
  if (useLottieFile && lottieFile?.[0]?.url) {
    return (
      <LottieMedia
        animation={lottieFile[0].url}
        fallbackSrc={featuredImage.url}
        alt={featuredImage.alt}
        loop={true}
        renderer="svg"
      />
    );
  }

  return <>
    <Image src={featuredImage.url} width={featuredImage.width} height={featuredImage.height} alt={featuredImage.alt} className="hidden md:block" />
    <Image src={mobileFeaturedImage.url} width={mobileFeaturedImage.width} height={mobileFeaturedImage.height} alt={mobileFeaturedImage.alt} className="block md:hidden" />
  </>
}

export const mapProps = (entry: any): ThreeColumnMediaFullProps => {
  if (entry.__typename == 'comparisonModules_threexBenefits_BlockType') {

    return {
      title: entry.header,
      features: mapBenefits(entry.benefits),
      styleOverrides: {
        bottomMarginSpacing: 'none',
        topMarginSpacing: 'none'
      }
    };
  }

  const data = Array.isArray(entry?.moduleProduct3xBenefits)
    ? entry.moduleProduct3xBenefits[0]
    : entry?.moduleProduct3xBenefits;

  return {
    title: <SerifAndSansSerifHeadline {...data.header[0]} />,
    features: mapBenefits(data.benefits),
    mainImage: mapMainImage({
      featuredImage: data.featuredImage[0],
      mobileFeaturedImage: data.mobileFeaturedImage[0],
      useLottieFile: data.useLottieFile,
      lottieFile: data.lottieFile,
    }),
  }
}
